import axios from 'axios'
import baseUrl from '../config.json'

export const getlist = ()=>{
    return axios.get(baseUrl.apiEndPoint+"/api/getlist")
}

export const savelist = (data)=>{
    return axios.post(baseUrl.apiEndPoint+"/api/addaproval",data)
}
export const updatelist = (id,data)=>{
    return axios.put(baseUrl.apiEndPoint+"/api/updateapproval/"+id,data)
}
export const searchlist = (data)=>{
    return axios.post(baseUrl.apiEndPoint+"/api/searchapproval",data)
}
export const getcount = ()=>{
    //alert('hi')
    return axios.get(baseUrl.apiEndPoint+"/api/getcount")
}

export const deletelist = (id)=>{
    return axios.get(baseUrl.apiEndPoint+"/api/approval/"+id+"/delete")
}
export const searchdate = (data)=>{
    return axios.post(baseUrl.apiEndPoint+"/api/searchdate",data)
}
export const getnotification = ()=>{
    return axios.get(baseUrl.apiEndPoint+"/api/getnotification")
}
export const savedetails = (data)=>{
    return axios.post(baseUrl.apiEndPoint+"/api/savedetails",data)
}
export const updatedetails = (id,data)=>{
    return axios.put(baseUrl.apiEndPoint+"/api/updatedetails/"+id,data)
}
export const getdetails= (data)=>{
    return axios.post(baseUrl.apiEndPoint+"/api/getdetails/",data)
}
// export const getdetails= (id)=>{
//     return axios.get(baseUrl.apiEndPoint+"/api/getdetails/:id")
// }
export const deletedetails = (id)=>{
    return axios.get(baseUrl.apiEndPoint+"/api/details/"+id+"/delete")
}
export const getinstadetails=(data)=>{
    return axios.post(baseUrl.instaApiEndPoiny+"/api/home/GetInstaApprovalBillDetails/",data)
}
const api={
    getlist,
    savelist,
    updatelist,
    searchlist,
    getcount,
    searchdate,
    deletelist,
    getnotification,
    savedetails,
    updatedetails,
    getdetails,
    deletedetails,
    getinstadetails
}
export default api